/**
 * Les deux regles d'affichage de l'ecran des courriers qu'un remaniement casse
 * sans bruit.
 *
 * Extraites du composant parce qu'elles l'ont deja ete cassees, et que le depot
 * n'a pas de bibliotheque de rendu : ce qui n'est pas extrait n'est pas teste.
 */

/**
 * La largeur que le tableau doit se reserver, calculee et non ecrite a la main.
 *
 * POURQUOI ON LA CALCULE. Des qu'une colonne porte `ellipsis` et que le
 * defilement horizontal est actif, rc-table passe la table en
 * `table-layout: fixed` : les largeurs ne viennent plus que du `<colgroup>`, et
 * ce qui depasse `scroll.x` sort du champ visible sans que rien ne le signale.
 *
 * Le defaut est DEJA arrive une fois sur cet ecran - « Objet » s'affichait sur
 * zero pixel - et le correctif avait ajuste le nombre a la main. Le nombre a
 * re-derive des la colonne suivante, et c'est « Sinistre » qui est sortie du
 * champ. Un nombre ecrit a la main se desynchronise toujours ; une somme, non.
 *
 * Une colonne sans largeur est comptee pour zero plutot que de rendre `NaN` :
 * `scroll.x` a NaN desactive le defilement en silence, et tasse le tableau.
 */
export function largeurTotale(colonnes) {
  if (!Array.isArray(colonnes)) return 0;
  return colonnes.reduce((somme, c) => {
    const l = Number(c && c.width);
    return somme + (Number.isFinite(l) ? l : 0);
  }, 0);
}

/**
 * Les lignes a afficher, pour un segment et un onglet donnes.
 *
 * DEUX POPULATIONS DANS LA MEME TABLE. Un courrier SAISI porte toujours un
 * registre journalier. La synchronisation IMAP, elle, enregistre chaque message
 * de la boite de reception en `Courrier` sans jamais toucher au registre - et
 * sans aucun sinistre rattache. `registreJourTrackingId` les distingue.
 *
 * LE DEFAUT QU'ON FERME. Le segment n'etait applique que sur l'onglet « non
 * traites » : « traites » et « tous » relisaient la liste entiere. La table se
 * remplissait alors de mails rapatries, dont la colonne Sinistre est vide par
 * construction, tandis que les libelles d'onglets comptaient la population
 * filtree. L'onglet annoncait douze lignes, la table en montrait
 * quatre-vingt-sept.
 *
 * L'ordre compte : on filtre la POPULATION d'abord, l'onglet ensuite. L'inverse
 * donnerait des comptes justes par accident sur certaines combinaisons.
 */
export function donneesAffichees(items, origine, onglet) {
  if (!Array.isArray(items)) return [];

  const population = origine === 'tous'
    ? items
    : origine === 'registre'
      ? items.filter((c) => c && c.registreJourTrackingId)
      : items.filter((c) => c && !c.registreJourTrackingId);

  if (onglet === 'non_traites') return population.filter((c) => !c.traite);
  if (onglet === 'traites') return population.filter((c) => c.traite);
  // Tout autre onglet - « tous », ou un onglet ajoute plus tard - montre la
  // population entiere. Rendre une liste vide cacherait l'ecran sans rien dire.
  return population;
}
